import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from "react-input-mask";
import moment from 'moment';
import React, { useState, useEffect } from "react";

const CustomDatePicker = (props) => {
  const [date,setDate]= React.useState('');
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  const handleDateChange =(date,name)=>{
    setDate(date);
    props.handleDateChange(moment(date).format('DD-MMM-YYYY'),name);

  }
  return (
    <>
      <DatePicker
        customInput={<InputMask type="text"  />}
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled
        }) => (
          <div className="input-group input-group-sm input-group-calender">
            <div className="input-group-prepend">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  decreaseMonth();
                }}
                disabled={prevMonthButtonDisabled}
                className="btn btn-outline-secondary"
                type="button"
              >
                {"<"}
              </button>
            </div>

            <input
              type="number"
              onChange={({ target: { value } }) => changeYear(value)}
              value={date.getFullYear()}
              className="form-control"
              placeholder=""
              aria-label=""
              aria-describedby="basic-addon1"
            />
            <select
              className="form-control"
              value={months[date.getMonth()]}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <div className="input-group-append">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  increaseMonth();
                }}
                className="btn btn-outline-secondary"
                disabled={nextMonthButtonDisabled}
              >
                {">"}
              </button>
            </div>
          </div>
        )}
        wrapperClassName={props.wrapperClassName}
        className={props.isinvalid?'form-control is-invalid':'form-control'}
        dateFormat="DD-MMM-YYYY"
        minDate={false}
        selected={props.selected}
        // onChange={props.onChange}
        autoComplete="off"
        showIcon
        placeholderText={props.placeholderText}
        maxDate={props.maxDate}
        id={props.id}
        name={props.name}
        onChange={(date)=>{ handleDateChange(date,props.name)}}
        icon="fa fa-calendar"
        value={props.value}
      />
    </>
  );
};



export default CustomDatePicker;
